export const DISMISSED_ONBOARDINGS_KEY = 'dismissedOnboardings';
export const UNSUPPORTED_BROWSER_EXPIRED_DATE_KEY = 'browserNotificationExpiredDate';
export const TOKEN_KEY = 'token';
export const SELECTED_UNITS_KEY = 'units';
export const LISTING_COLUMNS_CONFIG_KEY = 'columnsConfig';
export const CMS_PREVIEW_DATA_KEY = 'pagePreviewData';
export const CMS_CLIPBOARD_KEY = 'cmsClipboard';
export const REDESIGN_NOTIFICATION_EXPIRATION_DATE_KEY = 'redesignNotificationExpirationDate';
export const REDESIGN_ONBOARDING_MODAL = 'showRedesignOnboardingModal';
